import { render, staticRenderFns } from "./NewReservationsChart.vue?vue&type=template&id=245abc37&scoped=true&"
import script from "./NewReservationsChart.vue?vue&type=script&lang=js&"
export * from "./NewReservationsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245abc37",
  null
  
)

export default component.exports